import React from "react";
import { ProductSubTypes } from "../models/Service";

export type ProductSubtype = (typeof ProductSubTypes)[number];

interface SelectedServiceSubTypeContextValue {
  selectedSubTypes: ProductSubtype[];
  setSelectedSubTypes: (value: ProductSubtype[]) => void;
}

const SelectedServiceSubTypeContext =
  React.createContext<SelectedServiceSubTypeContextValue | null>(null);

export const SelectedServiceSubTypeProvider = ({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  const [selectedSubTypes, setSelectedSubTypes] = React.useState<ProductSubtype[]>([]);
  const contextValue = React.useMemo(
    () => ({
      selectedSubTypes,
      setSelectedSubTypes
    }),
    [selectedSubTypes]
  );

  return React.createElement(
    SelectedServiceSubTypeContext.Provider,
    { value: contextValue },
    children
  );
};

export function useSelectedServiceSubType(): SelectedServiceSubTypeContextValue {
  const context = React.useContext(SelectedServiceSubTypeContext);
  if (!context) {
    throw new Error("useSelectedServiceSubType must be used within SelectedServiceSubTypeProvider");
  }
  return context;
}
